<script>
import formatDate from '@utils/format-date'
import formatCurrency from "@utils/format-currency";
import  { formatOrder } from "@utils/format-order";
import { merchantComputed } from "@store/helpers";
import { orderIsCanPay, orderIsOffline, orderParamsList } from "@utils/ipetbooking-order";
import formatPrice from "@utils/format-price";
// import { conditionList } from "@utils/is-condition";

const statusColor = {
  pending: 'danger',
  processing: 'warning',
  'shipment-proc': 'complete',
  'shipment-return': 'gray-1',
  completed: 'complete',
  cancelled: 'gray-1',
  refunded: 'danger',
}

export default {
  props: {
    orderList: {
      type: Array,
      default: () => {
        return []
      }
    },
    status: {
      type: String,
      default: 'available',
      validator: (val) => ['available', 'used', 'expired'].includes(val),
    },
  },
  data() {
    return {
      statusColor,
    }
  },
  computed: {
    ...merchantComputed,
    formatOrderList() {
      return this.orderList.map(item => {
        return {
          storeList: [],
          head: [],
          body: [
            {
              title: '',
              titleClass: '',
              text: `${item.code}<small>${item.description}</small>`,
              textClass: '',
              class: '',
            },
            {
              title: '',
              titleClass: '',
              text: `<span class="${this.$style.coupon}">${item.discount.display}</span>`,
              textClass: '',
              class: 'HELLO',
            },
            {
              title: '最低消費',
              titleClass: '',
              text: item.minAmount === '' ? '無低消' : `NT$ ${formatCurrency(item.minAmount)}`,
              textClass: '',
              class: '',
            },
            {
              title: '使用期限',
              titleClass: '',
              text: this.formatUsagePeriod(item),
              textClass: '',
              class: '',
              condition: () => {
                return this.isAvailable
              }
            },
            {
              title: '使用日期',
              titleClass: '',
              text: formatDate(item.used_date, 'yyyy/MM/dd'),
              textClass: '',
              class: '',
              condition: () => {
                return this.isUsed
              }
            },
          ],
          addOrder: [],
          foot: [
            {
              type: 'button',
              text: '查看',
              class: 'flex-grow-1',
              buttonClass: 'isStyleDark isOutline3 isRadius isFull',
              onClick: () => {
                this.goToOrderItem(item);
              },
              condition: () => {
                return this.isUsed
              }
            },
          ]
        }
      })
    },
    isAvailable() {
      return this.status === 'available' ? '' : 'couponList__hidden'
    },
    isUsed() {
      return this.status === 'used' ? '' : 'couponList__hidden'
    },
  },
  methods: {
    formatOrder,
    orderIsCanPay,
    formatPrice,
    formatDate,
    formatCurrency,
    goToOrderItem(item) {
      if (this.status === 'used')
        this.$router.push({
          name: 'shop-member-shopping-item',
          params: {
            orderId: item.order_id
          }
        })
    },
    openDialogContact(storeList) {
      this.$globalDialog('DialogContact', {
        storeList
      });
    },
    isOffline(orderItem) {
      return orderIsOffline({
        order: orderItem,
        ordertype: 'order',
        type: 'reservation',
        isList: true
      });
    },
    formatUsagePeriod({startDate, expireDate}) {
      if (!!startDate && !!expireDate)
        return `${formatDate(startDate, 'yyyy/MM/dd')} - ${formatDate(expireDate, 'yyyy/MM/dd')}`
      if (!!startDate && expireDate === '')
        return `起始日期 ${formatDate(startDate, 'yyyy/MM/dd')} `
      if (startDate === '' && !!expireDate)
        return `即日起至 ${formatDate(expireDate, 'yyyy/MM/dd')}`
      
      return '無限制'
    }
  }
}
</script>
<!-- section template -->
<template>
  <div :class="$style.couponListSectionList">
    <BaseOrderListJtails
      :loading="$isLoading('fetchCouponList')"
      loading-text="取得折價券資訊..."
      :order-list="formatOrderList"
      class="d-xl-none"
    />
    <el-table
      v-loading="$isLoading('fetchCouponList')"
      element-loading-text="取得折價券資訊..."
      :data="orderList"
      class="isStyleBase isRowPointer mb-5 d-none d-xl-block"
      :class="$style.couponList"
      @row-click="goToOrderItem"
    >
      <el-table-column v-slot="{ row }" label="優惠券代碼">
        <span class="ls-sm">{{ row.code }}</span><br>
        <span>{{ row.description }}</span>
      </el-table-column>

      <el-table-column v-slot="{ row }" label="優惠方式" align="center">
        <span
          :class="$style.coupon"
          class="d-inline-block fw-medium font-number"
        >
          {{ row.discount.display }}
        </span>
      </el-table-column>

      <el-table-column v-slot="{ row }" label="最低消費" align="left" width="150">
        <span class="font-number">{{ row.minAmount === '' ? '無低消' : `NT$ ${formatCurrency(row.minAmount)}` }}</span>
      </el-table-column>

      <el-table-column v-slot="{ row }" :label="isAvailable ? '' : '使用期限'" :width="isAvailable ? '1' : ''">
        <span v-if="isAvailable ? false : true" class="font-number" :class="{ 'couponList__hidden': !!isAvailable }">{{ formatUsagePeriod(row) }}</span>
      </el-table-column>

      <el-table-column v-slot="{ row }" :label="isUsed ? '' : '使用日期'" :width="isUsed ? '1' : ''">
        <span v-if="isUsed ? false : true" class="font-number" :class="{ 'couponList__hidden': !!isUsed }">{{ `${formatDate(row.used_date, 'yyyy/MM/dd')}` }}</span>
      </el-table-column>

      <el-table-column v-slot="{ row }" :label="isUsed ? '' : '查看'" :width="isUsed ? '1' : '80'" align="center">
        <BaseButton
          v-if="isUsed ? false : true"
          event
          class="isStyleSecondary isText"
          @click.stop.prevent
        >
          <i class="fontello fontello-view fa-2x"></i>
        </BaseButton>
      </el-table-column>
    </el-table>
    <BasePre>orderList: {{ orderList }}</BasePre>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.couponListSectionList {
  min-height: 532px;

  :global {
    .couponListSectionList {
      &__dropdown {
        width: 100%;
        font-size: 1rem;
      }
    }
  }
}

.couponList {
  :global {
    .couponList {
      &__title {
        font-weight: 500;
      }

      &__date, &__meta {
        font-size: 0.75rem;
        color: $color-gray-2;
        letter-spacing: 0.1em;
      }

      &__hidden {
        opacity: 0;
      }
    }

    // stylelint-disable selector-class-pattern
    .el-table__expand-column {
      padding: 0;

      > .cell {
        padding: 0;

        > .el-table__expand-icon {
          height: 95px;
        }
      }
    }

    // stylelint-enable selector-class-pattern
  }
}

.coupon {
  border: 1px solid $color-wp-primary;
  border-radius: 4px;
  padding: 5px 20px;
  color: $color-wp-primary;

  @media screen and (max-width: 1500px) {
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
